'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _withCarousel = require('./with-carousel');

var _util = require('./util');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable react/sort-comp */
var Carousel = function (_Component) {
    (0, _inherits3.default)(Carousel, _Component);

    function Carousel() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, Carousel);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Carousel.__proto__ || (0, _getPrototypeOf2.default)(Carousel)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            currentSlide: _this.props.defaultCurrentSlide,
            totalSlides: _this.props.totalSlides
            // isFullscreen: false,
        }, _this.setTotalSlides = function (totalSlides) {
            _this.setState(function (state) {
                if (totalSlides !== state.totalSlides) {
                    return {
                        totalSlides: totalSlides
                    };
                }
                return null;
            });
        }, _this.changeSlide = function (requestedSlide) {
            var nextSlide = (0, _util.inRange)(requestedSlide, {
                max: _this.state.totalSlides,
                infinite: _this.props.infinite
            });

            if (nextSlide !== _this.getCurrentSlide()) {
                if (!_this.isControlled()) {
                    _this.setState({ currentSlide: nextSlide });
                }

                _this.props.onSlideChange(nextSlide);
            }
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(Carousel, [{
        key: 'getBroadcast',
        value: function getBroadcast() {
            var infinite = this.props.infinite;
            var totalSlides = this.state.totalSlides;


            return {
                theme: this.props.theme,
                currentSlide: this.getCurrentSlide(),
                infinite: (0, _util.allowInfinite)(infinite, totalSlides),
                onSlideChange: this.changeSlide,
                totalSlides: this.state.totalSlides,
                setTotalSlides: this.setTotalSlides
            };
        }
    }, {
        key: 'isControlled',
        value: function isControlled() {
            var currentSlide = this.props.currentSlide;


            return currentSlide != null;
        }
    }, {
        key: 'getCurrentSlide',
        value: function getCurrentSlide() {
            var _ref2 = this.isControlled() ? this.props : this.state,
                currentSlide = _ref2.currentSlide;

            return currentSlide;
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                children = _props.children,
                theme = _props.theme;


            return _react2.default.createElement(
                _withCarousel.CarouselBroadcast,
                { carousel: this.getBroadcast() },
                _react2.default.createElement(
                    'div',
                    { className: theme.carousel, 'data-test-tag': '@spp/ui-carousel' },
                    children
                )
            );
        }
    }]);
    return Carousel;
}(_react.Component);

Carousel.propTypes = {
    totalSlides: _propTypes2.default.number,
    currentSlide: _propTypes2.default.number,
    defaultCurrentSlide: _propTypes2.default.number,

    children: _propTypes2.default.node.isRequired,
    // fullscreen: PropTypes.bool,
    infinite: _propTypes2.default.bool,

    // onFullscreenEnter: PropTypes.func,
    // onFullscreenLeave: PropTypes.func,
    onSlideChange: _propTypes2.default.func,

    theme: _propTypes2.default.shape({
        carousel: _propTypes2.default.string,
        slideContainer: _propTypes2.default.string,
        slideContainerViewport: _propTypes2.default.string,
        slide: _propTypes2.default.string,
        slideItemWrapper: _propTypes2.default.string,
        changeSlideButton: _propTypes2.default.string,
        changeSlideButtonDisabled: _propTypes2.default.string,
        previousSlideButton: _propTypes2.default.string,
        nextSlideButton: _propTypes2.default.string
    })
};
Carousel.defaultProps = {
    currentSlide: undefined,
    defaultCurrentSlide: 0,
    totalSlides: 0,

    fullscreen: false,
    infinite: false,

    // onFullscreenEnter: () => {},
    // onFullscreenLeave: () => {},
    onSlideChange: function onSlideChange() {},

    theme: {}
};
exports.default = Carousel;
//# sourceMappingURL=Carousel.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-carousel/lib/cjs/Carousel.js
 ** module id = 583
 ** module chunks = 1
 **/